var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"layout"},[_c('l-header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('l-footer',{attrs:{"about":_vm.about}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }